module.exports = __webpack_public_path__ + "static/media/05.d39de5e9.jpg";